export default __webpack_public_path__ + "static/media/btclogo.96689d13.png";